import React from "react";
import styled from "styled-components";

import { Label } from "@examspark/common-ui";

const RestyledLabel = styled(Label)`
  span {
    text-transform: none;
  }
`;

const FormLabel = ({
  children,
  ...props
}: React.HTMLAttributes<HTMLLabelElement> & {
  label: string | React.ReactNode;
}) => {
  return <RestyledLabel {...props}>{children}</RestyledLabel>;
};

export default FormLabel;
